import React from "react";

import { Container, Content } from "./styles";

export default function Footer() {
  return (
    <Container>
      <Content>
        <span>Serafine 2020 © Todos os direitos reservados</span>
        <span>Universidade Serafine</span>
      </Content>
    </Container>
  );
}
